import moment from 'moment';

export const createSelectOptions = (arr, key, description, sort) => {
    if (arr) {
        let returnArr = [...arr];
        if (sort) {
            returnArr = returnArr.sort((a, b) => {
                return a[description] > b[description] ? 1 : -1;
            });
        }

        return returnArr.map(o => <option value={o[key]} key={o[key]}>{o[description]}</option>);
    }
    return arr;
}

export const getRubrosByType = (rubros, type) => {
    return rubros?.filter(r => r.tipo === type);
}

export const separador = (numero) => {
    //return cantidad de line separadoras segun numero recibido
    const line = <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>;

    let lines = [];
    for (let i = 0; i < numero; i++) {
        lines.push(line);
    }
    return lines;
}

export const getPermissions = (role) => {
    if (role) {
        role = role.toString();
        let roles = {
            admin: role.includes('a'),
            requests: {
                view: role.includes('v'),
                edit: role.includes('e'),
                delete: role.includes('d'),
            },
            contracts: {
                view: role.includes('V'),
                edit: role.includes('E'),
                delete: role.includes('D'),
            }
        }

        return roles;
    }
    return null;
}

export function dateIsBetweenRange(date, startDate, endDate) {
    return moment(date).isBetween(startDate, endDate, null, '[]');
}

export function formatDate(date, format) {
    let res = moment(date).format(format);
    if (res === 'Invalid date' || res === 'Fecha inválida') {
        return '';
    }
    return res;
}

export const replaceQuotes = (obj) => {
    //for each value in obj, replace double quotes with \" to avoid errors in json"
    let newObj = {};
    for (let key in obj) {
        newObj[key] = obj[key].toString().replace(/"/g, '\\"');
        newObj[key] = newObj[key].toString().replace(/'/g, '\\"');
    }
    return newObj;
}